// Aggregates per-form Hebrew verb drill progress (stored by the backend in
// hebrew_verb_progress, keyed by form id) into per-verb summaries and
// displayable mastery buckets shared by the library + conjugation table.

export const MASTERY_MASTERED = 4;

export const MASTERY_BUCKETS = [
  {key: 'new', label: 'New', color: 'var(--text-tertiary)'},
  {key: 'learning', label: 'Learning', color: 'var(--brand)'},
  {key: 'review', label: 'Review', color: 'var(--amber)'},
  {key: 'mastered', label: 'Mastered', color: 'var(--green)'},
];

export function masteryBucket(level = 0) {
  const l = Number(level) || 0;
  if (l >= MASTERY_MASTERED) return MASTERY_BUCKETS[3];
  if (l >= 3) return MASTERY_BUCKETS[2];
  if (l >= 1) return MASTERY_BUCKETS[1];
  return MASTERY_BUCKETS[0];
}

// forms: normalized verb forms (each has an `id`)
// progressMap: { [formId]: { masteryLevel, correctCount, incorrectCount, lastReviewed } }
export function summarizeVerbProgress(forms = [], progressMap = {}) {
  let correct = 0;
  let incorrect = 0;
  let mastered = 0;
  let learning = 0;
  let newCount = 0;
  let totalMastery = 0;

  forms.forEach((f) => {
    const p = progressMap[f.id];
    const level = p ? Number(p.masteryLevel) || 0 : 0;
    if (p) {
      correct += Number(p.correctCount) || 0;
      incorrect += Number(p.incorrectCount) || 0;
    }
    if (level >= MASTERY_MASTERED) mastered++;
    else if (level >= 1) learning++;
    else newCount++;
    totalMastery += level;
  });

  const total = forms.length;
  const reviews = correct + incorrect;
  const accuracy = reviews > 0 ? Math.round((100 * correct) / reviews) : null;
  const avgMastery = total > 0 ? totalMastery / total : 0;
  const overall = masteryBucket(Math.round(avgMastery));

  return {
    total,
    mastered,
    learning,
    newCount,
    correct,
    incorrect,
    reviews,
    accuracy,
    avgMastery,
    overall,
  };
}
